module.exports = __webpack_public_path__ + "static/media/MenuViewer.73bdec49.svg";